import { render, staticRenderFns } from "./StatisticsDeliver.vue?vue&type=template&id=6d2fa994&"
import script from "./StatisticsDeliver.vue?vue&type=script&lang=js&"
export * from "./StatisticsDeliver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports